export default "__VITE_ASSET__Ms6QVlhj__"